import '../styles/dossiers.css';
import { useState } from 'react';

/**
 * Un identifiant technique, lisible et copiable (01/11/2026) : l'UUID d'un
 * espace ou d'un dossier, demandé par les réglages (Connect, back-office) et
 * par le support. Affiché discrètement, en police à chasse fixe.
 */
export function IdentifiantCopiable({ libelle, valeur }: { libelle: string; valeur: string }) {
  const [copie, setCopie] = useState(false);
  const copier = async () => {
    try {
      await navigator.clipboard.writeText(valeur);
      setCopie(true);
      setTimeout(() => setCopie(false), 2000);
    } catch {
      setCopie(false);
    }
  };
  return (
    <p style={{ fontSize: '0.8rem', color: 'var(--text-color-light)', margin: '0 0 0.75rem', wordBreak: 'break-all' }}>
      {libelle} : <code>{valeur}</code>{' '}
      <button type="button" className="btn-lien" onClick={() => void copier()} aria-live="polite">
        {copie ? 'Copié' : 'Copier'}
      </button>
    </p>
  );
}
